import script from "./InteractionOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./InteractionOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./InteractionOverlay.vue?vue&type=style&index=0&id=73ed0838&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73ed0838"]])

export default __exports__